
import pubsub from "@viewlift/pubsub"
import Cookies from 'js-cookie'
import { callRequest } from "../../../Graphql/request"
import trackEvent from "./analyticsMap"
import { fetchPublicKey, fetchUserData, getDeviceId, getToken } from "../../../helpers"
import { FB_EVENTS } from "../../../helpers/analyticsMap"
import axios from "axios"
import forge from 'node-forge';
import { setToken } from "./constant"
import { publishAppLoading, publishErrorUpdate } from "../../Events/utils.events"
import localforage from "localforage"
import { triggerUserMergeEvent } from "../../helper"
import logger from "../../../logger"

export let login = async (creds,id,type = "initiate") => {
  let site = window?.app_data?.site?.siteInternalName || null
  let apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl|| null
  if(!site || !apiBaseUrl) return 

  if (type == "initiate") {
    let utmCookie = Cookies.get('utm')
    let utmData = utmCookie && JSON.parse(utmCookie)
    let variables = {
      "site": window?.app_data?.site?.siteInternalName,
      "device": "web_browser",
      "email": creds.email,
      "emailConsent": true,
      "campaign": (utmData && utmData.utm_campaign) || "",
      "campaignSource": (utmData && utmData.utm_medium) || "",
      "campaignMedium": (utmData && utmData.utm_medium) || "",
      "deviceName" : "",
      "action": "SIGNIN"
    }
    let cb = () => console.log("cb")
    return callRequest({type : "initiateEmail", variables,cb})
  }
    if (type == "validate") {
      let cb = () => console.log("cb")
      let deviceId = getDeviceId();
      let variables = {
        "site": window?.app_data?.site?.siteInternalName,
        "key": creds?.key,
        "otp" : creds?.otpValue
      }
      return callRequest({type : "initiateEmailValidate", variables,cb}).then( response => {
        let res = response?.identityAuthOtpValidate
          let token = res && {
            authorizationToken: res.authorizationToken,
            refreshToken: res.refreshToken
          }
          setToken(token)
        if(res.existingUser) {
          trackEvent('login', {method: "Email", userId: res.userId, phoneNumber: res.phoneNumber || 'NA', email: res.email || 'NA'},null)
          pubsub.publish('FB-analytics',{eventType : FB_EVENTS.LOGIN ,payload : {platform: 'Web', registrationType: 'Native'},type : "FB"})
        } else {
          trackEvent('sign_up', {method: "Email", userId: res.userId, phoneNumber: res.phoneNumber || 'NA', email: res.email || 'NA'},null)
          pubsub.publish('FB-analytics',{eventType : FB_EVENTS.COMPLETE_REGISTRATION ,payload : {platform: 'Web', registrationType: 'Native'},type : "FB"})
        }
        localStorage.setItem('deviceId',deviceId)
        return response
      })
    }
  }

  export const encryptWithPublicKey = async(item) => {
    try {
      const {data} = await fetchPublicKey()
      const publicKey = forge.pki.publicKeyFromPem(data);
      const encrypted = publicKey.encrypt(item, 'RSA-OAEP');
      return forge.util.encode64(encrypted);
    } catch (error) {
      console.error('Error encrypting data:', error);
      return null;
    }
  };
  

  export const createAccountViaEmailPhone = async(payload, isCheckout=false) => {
    try{
    const token = await getToken();
    const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
    const deviceId = getDeviceId()
    const encryptData =  await encryptWithPublicKey(Object.values(payload)[0])
    const encryptKeyName = Object.keys(payload)[0]
    const finalPayload = {[encryptKeyName]: encryptData}
    const mergedPayload = {...payload, ...finalPayload}
    let endpoint = `${apiBaseUrl}/v2/identity/account?deviceId=${deviceId}`;
    let headers = {
      headers: { 'Authorization': token, 
      'x-api-key': window?.xApiKey
    }
    };
    return axios.post(endpoint, mergedPayload, headers).then((res) => {
      const authToken = res.data.authorizationToken
      const userId = res.data.userId
      let token = {
        authorizationToken: res.data.authorizationToken,
        refreshToken: res.data.refreshToken
      }
      setToken(token)
      if(!isCheckout){
        fetchUserData(userId, authToken)
      }
        triggerUserMergeEvent(res.data.existingUser)
      return {status : true}
    }).catch((err) => {
      logger(err, 'error')
    })
  }catch (e){
    publishAppLoading(false)
    publishErrorUpdate("Some Error")
    return {status : false}
  }
  }